export default __webpack_public_path__ + "static/media/cross.f151cf7d.svg";